import { Component, Input } from '@angular/core';

@Component({
  selector: 'libero-instruments-checksum-input',
  templateUrl: './instruments-checksum-input.component.html',
  styleUrls: ['./instruments-checksum-input.component.scss'],
  standalone: false
})
export class InstrumentsChecksumInputComponent {
  @Input() public desiredValue = 100;
  @Input() public displayUnits = '%';

  @Input() public actualValue!: number;

  public get _actualValue(): number {
    return parseFloat(this.actualValue.toFixed(2));
  }

  public set _actualValue(value: number) {
    this.actualValue = value;
  }

  public get validValue(): boolean {
    return this.actualValue === this.desiredValue;
  }
}
